import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAdminRole } from '@/hooks/useAdminRole';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { Button } from '@/components/ui/button';

/**
 * Gates a route behind the admin role. Used to keep in-progress features
 * (currently the Social hub) hidden from regular members.
 */
export const AdminOnlyRoute = ({ children }: { children: ReactNode }) => {
  const { isAdmin, loading } = useAdminRole();

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="min-h-dvh flex items-center justify-center px-6">
        <div className="max-w-md text-center space-y-3">
          <h1 className="text-xl font-semibold">Coming soon</h1>
          <p className="text-sm text-muted-foreground">
            The community and messaging area is still being built. We'll open it up to everyone shortly.
          </p>
          <Button asChild variant="secondary">
            <Link to="/">Back to home</Link>
          </Button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
